import React, { useEffect } from 'react';
import { AlertBar } from './components/AlertBar';
import { HeroSection } from './components/HeroSection';
import { BookMockup } from './components/BookMockup';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferSection } from './components/OfferSection';
import { FooterTrust } from './components/FooterTrust';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream-50 text-brown-800 font-body selection:bg-terra-500/20 selection:text-terra-600" data-id="element-0">
      <AlertBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BookMockup data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <OfferSection data-id="element-7" />
      </main>

      <FooterTrust data-id="element-8" />
    </div>;
}